<template>
  <div class="ma-3">
    <div class="title mb-3">
      Mileage fees
      <v-icon>mdi-chevron-right</v-icon>
      {{ isNew ? 'New period' : formatDate(fees.effective_date) }}
    </div>

    <v-form
      ref="form"
      v-model="formValid"
      layout="column"
      layout-align="center center"
      @submit.prevent="save"
    >
      <div>
        <div class="title font-weight-light mb-3">
          Fees period information
        </div>
        <v-text-field
          v-model="effective_date_text"
          label="Start date"
          outline
          hide-details
          class="mb-4"
          @blur="fees.effective_date = parseDate(effective_date_text)"
        >
          <div slot="prepend-inner">
            <v-menu
              ref="searchStart"
              :close-on-content-click="false"
              :return-value.sync="fees.effective_date"
              transition="scale-transition"
              offset-y
              full-width
              lazy
            >
              <v-icon slot="activator">
                event
              </v-icon>
              <v-date-picker
                v-model="fees.effective_date"
                first-day-of-week="1"
                @input="$refs.searchStart.save(fees.effective_date); effective_date_text = americanizeDate(fees.effective_date);"
              />
            </v-menu>
          </div>
        </v-text-field>
        <v-text-field
          v-model="fees.amount"
          outline
          label="Fees value"
          class="field-width"
          :rules="[ v => !!v || parseFloat(v) > 0 || 'This field is required' ]"
        />
      </div>

      <v-btn
        depressed
        color="primary"
        @click="save"
      >
        Save
      </v-btn>
      <router-link
        :to="{name: 'admin-fees-mileage-index'}"
        class="grey--text"
      >
        Cancel
      </router-link>
    </v-form>
  </div>
</template>

<script>
import Params from "@/api/params";
import GlobalMixin from "@/mixins/global";
import DatesMixin from "@/mixins/date";
import moment from "moment";

export default {
  mixins: [GlobalMixin, DatesMixin],
  data() {
    return {
      fees: {
        effective_date: null,
        amount: 0.00
      },
      formValid: false,
      effective_date_text: ""
    };
  },
  computed: {
    isNew() {
      return this.$route.params.id === "new";
    }
  },
  mounted() {
    if (!this.isNew) {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      Params.get("mileage-fees", this.$route.params.id).then(res => {
        this.fees = res.data
        this.effective_date_text = this.americanizeDate(this.fees.effective_date)
        this.fees.amount = this.fees.amount.replace('.', ',')
      });
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.fees.amount = this.fees.amount.replace(',', '.').replace(' ', '')
			if (this.isNew) {
        Params.create("mileage-fees", this.fees).then(() => {
          this.$router.push({ name: "admin-fees-mileage-index" });
          this.$snotify.success(
            `The period for mileage fees "${this.formatDate(this.fees.effective_date)}" has been created`
          );
        });
      } else {
        Params.update("mileage-fees", this.fees.id, this.fees).then(() => {
          this.$router.push({ name: "admin-fees-mileage-index" });
          this.$snotify.success(
            `The period for mileage fees "${this.formatDate(this.fees.effective_date)}" has been updated`
          );
        });
      }
    },
    americanizeDate(date) {
      if (!date) return null;

      if (date.indexOf(".") >= 0) {
        return date;
      }

      return moment(date, "YYYY-MM-DD").format("DD.MM.YYYY");
    },
    parseDate(date) {
      if (!date) return null;

      if (date.indexOf("-") >= 0) {
        return date;
      }

      return moment(date, "DD.MM.YYYY").format("YYYY-MM-DD");
    }
  }
};
</script>
